export const messages = {
  page: {
    title: {
      id: 'faqs.Page.Title',
      defaultMessage: 'Frequently Asked Questions',
    },
  },
};
